import {makeSystemModePath} from './shared/serverFunctions';

/**
 * Item Sales
 *      All, Filters
 *      by: Location, Loyalty, DBA, District, State
 *      by: State & City, State & DBA
 */
export const RESOURCES = {
    "ItemSalesCount": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Item Sales Count",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/itemSalesCount/" + startEndOffset
            }
        }
    },
    "ItemSalesAll": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Item Sales (All)",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/itemSales/" + startEndOffset
            }
        }
    },
    "ItemSalesCountByLocation": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Item Sales Count",
                "uri": localStorage.getItem('server') + "/api/v5/report/sale/" + systemMode + "/" + params.location_id + "/itemSalesCountByLocation/" + startEndOffset
            }
        }
    },
    "ItemSalesByLocation": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Item Sales by Location",
                "uri": localStorage.getItem('server') + "/api/v5/report/sale/" + systemMode + "/" + params.location_id + "/itemSalesByLocation/" + startEndOffset
            }
        }
    },
    "ItemSalesCountByDba": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Item Sales Count",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/itemSalesCountByDBA/" + params.dba_id + "/" + startEndOffset
            }
        }
    },
    "ItemSalesByDba": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Item Sales by DBA",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/itemSalesByDBA/" + params.dba_id + "/" + startEndOffset
            }
        }
    },
    "ItemSalesCountByDistrict": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Item Sales Count",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/itemSalesCountByDistrict/" + params.district_id + "/" + startEndOffset
            }
        }
    },
    "ItemSalesByDistrict": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Item Sales by District",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/itemSalesByDistrict/" + params.district_id + "/" + startEndOffset
            }
        }
    },
    "ItemSalesCountByState": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Item Sales Count",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/itemSalesCountByState/" + params.state + "/" + startEndOffset
            }
        }
    },
    "ItemSalesByState": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Item Sales by State",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/itemSalesByState/" + params.state + "/" + startEndOffset
            }
        }
    },
    "ItemSalesCountByStateCity": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Item Sales Count",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/itemSalesCountByCityState/" + params.state + "/" + params.city + "/" + startEndOffset
            }
        }
    },
    "ItemSalesByStateCity": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Item Sales by City and State",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/itemSalesByCityState/" + params.state + "/" + params.city + "/" + startEndOffset
            }
        }
    },
    "ItemSalesCountByStateDba": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Item Sales Count",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/itemSalesCountByDBAState/" + params.state + "/" + params.dba_id + "/" + startEndOffset
            }
        }
    },
    "ItemSalesByStateDba": {
        GET_LIST: function (params) {
            let systemMode = makeSystemModePath();
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Item Sales by City and DBA",
                "uri": localStorage.getItem('server') + "/api/v5/report/sales/" + systemMode + "/itemSalesByDBAState/" + params.state + "/" + params.dba_id + "/" + startEndOffset
            }
        }
    }
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "ItemSalesByState"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseItemSalesReportsResourceMap.js